import type zh from '../zh/common';

/** Shared UI text, English. Typed against the zh file so a missing key fails tsc. */
const common: typeof zh = {
  language: {
    zh: '中文',
    en: 'English',
  },
};

export default common;
